import enums from "../Helper/enums";

export const UrlDoc = "https://claimsupload.fhnid.com";

export const baseUrl = enums.envProd
  ? enums.prodUrl
  : enums.envStage
  ? enums.stgUrl
  : enums.envDevServer
  ? enums.devServerUrl
  : enums.envDevOld
  ? enums.devOldUrl
  : enums.devUrl;

export const ssoUrl = enums.envProd
  ? enums.ssoProdUrl
  : enums.envStage
  ? enums.ssoUATUrl
  : enums.envDevServer
  ? enums.ssoUATUrl
  : enums.envDevOld
  ? enums.ssoUATUrl
  : enums.ssoDevUrl;

export const URL_DELETE_DOC_CLAIM = baseUrl + "/claim";

export const URL_CREATE_INVOICE = baseUrl + "/invoice";

export const URL_CLAIM_DOC = baseUrl + "/claim/doc";

export const URL_CLAIM_STATUS = baseUrl + "/claim/status";

export const URL_CLAIM_LIST = baseUrl + "/claim";

export const URL_CLAIM_PENDING_LIST = baseUrl + "/claim/pending";

export const URL_CLAIM_DETAIL_PENDING = baseUrl + "/claim/param1/param2/param3";

export const URL_INVOICE_LIST = baseUrl + "/invoice";

export const URL_UPLOAD_FILE_CLAIM = baseUrl + "/claim/upload";

export const URL_CHECK_SESSION = baseUrl + "/auth/session";

export const URL_SUBMIT_CLAIM_FONE = baseUrl + "/f1/submitclaimf1";

export const URL_FONE_CHECK_ELIGIBILITY = baseUrl + "/f1/eligibilityf1";

export const URL_REGISTER_FONE = baseUrl + "/f1/registerf1";

export const URL_EXCLUSION_FONE = baseUrl + "/f1/checkexclusionf1";

export const URL_CREATEINV = baseUrl + "/transaction/edcTransaction/createINV";

export const URL_DOC_FORM = baseUrl + "/doc/form?id=param";

export const URL_FIND_INVOICENUMBER =
  baseUrl + "/transaction/edcTransaction/invoice_number";

export const URL_EDITINVOICE =
  baseUrl + "/transaction/edcTransaction/invoice/update";

export const URL_LIST_INVOICE_EDIT =
  baseUrl + "/transaction/edcTransaction/invoice_listedit";

export const URL_INVOICE_EDIT =
  baseUrl + "/transaction/edcTransaction/invoice_toedit";

export const URL_GET_LISTDOC = UrlDoc + "/listFiles?claimid=CLAIMID";
export const URL_GET_PAYMENTINVOICE =
  baseUrl + "/transaction/edcTransaction/invoice";

export const URL_GET_PAYMENTBYDATE =
  baseUrl + "/transaction/edcTransaction/date";

export const URL_SEARCH_PAYMENT =
  baseUrl + "/transaction/edcTransaction/payment/search";

export const URL_DELETE_Doclist = baseUrl + "/transaction/doc/claim";
export const URL_DELETE_FILE = UrlDoc + "/uploads?claimid=claimID&id=ID";

export const URL_UPLOAD =
  UrlDoc +
  "/uploads?clientid=param1&coyid=param2&year=param3&month=param4&date=param5&providerid=param6&claimid=param7";

export const URL_TRANSACTION_Payment =
  baseUrl +
  "/transaction/edcTransaction/payment/:page/?providerCode=params&id=param2";
export const URL_LOGIN = baseUrl + "/users/login";
export const URL_LOGIN_V2 = baseUrl + "/users/loginv2";
export const URL_VERIFY_OTP = baseUrl + "/users/otp/param1/param2";
export const URL_RESEND_OTP =
  baseUrl + "/users/otp/resend/param1/param2/param3";
export const URL_LOGOUT = baseUrl + "/users/logout";
export const URL_REGISTER = baseUrl + "/users/register";
export const URL_CHANGE_PASSWORD = baseUrl + "/users/changePassword";

export const URL_UPDATE_USERNAME = baseUrl + "/users/change-username";

export const URL_FORGOT_PASSWORD = baseUrl + "/users/forgotPassword";
export const URL_GET_CLINIC = baseUrl + "/clinic/getClinic/params";
export const URL_VERIFY_EDC_MEMBER = baseUrl + "/edcMember/edcMemberVerify";
export const URL_VERIFY_EDC_MEMBER_EMPLOYEE =
  baseUrl + "/edcMember/verification";
export const URL_REGISTER_EDC_MEMBER = baseUrl + "/edcMember/registerMemberEdc";
export const URL_VERIFY_EDC_MEMBER_DOB =
  baseUrl + "/edcMember/edcMemberVerifyWithDOB";
export const URL_VOID_CLAIM = baseUrl + "/edcDiagnostic/edcVoidClaim";
export const URL_INQUIRY_PAYMENT = baseUrl + "/edcDiagnostic/edcEnquiryPayment";
export const URL_GET_DIAGNOSTIC =
  baseUrl + "/edcDiagnostic/getDiagnostic?id=param";
export const URL_CHECKOUT_PAYMENT =
  baseUrl + "/edcDiagnostic/edcCheckoutPayment";
export const URL_SEARCH_TRANSACTION_BY_TRACE_NO =
  baseUrl + "/transaction/searchTransactionBytraceNo?traceNo=param1&id=param2";
export const URL_CLAIM_ITEM = baseUrl + "/edcDiagnostic/edcClaimItem";
export const URL_CALCULATE_ITEM = baseUrl + "/edcDiagnostic/edcCalculateItem";
export const URL_CREATE_TRANSACTION =
  baseUrl + "/transaction/edcCreateTransaction";
export const URL_GETALL_TRANSACTION =
  baseUrl + "/transaction/edcAllTransaction/params";
export const URL_GET_FILTER_TRANSACTION =
  baseUrl +
  "/transaction/edcTransactionByRequest?startDate=param1&endDate=param2&transactionType=param3&providerCode=param4&id=param5";
export const URL_GET_PER_TRANSACTION_ALL =
  baseUrl +
  "/transaction/edcGetTransactionAllPerTransaction?transactionType=param1&providerCode=param2&id=param3&page=param4&size=param5";
export const URL_GET_PER_TRANSACTION_FILTER =
  baseUrl +
  "/transaction/edcGetTransactionFilter?startDate=param1&endDate=param2&transactionType=param3&providerCode=param4&cardNumber=param5&id=param6&page=param7&size=param8";
export const URL_GET_ICD_ALL = baseUrl + "/icd/getAll?id=param";
export const URL_ICD_SEARCH =
  baseUrl + "/icd/search?dataSearch=param&id=param1";
export const URL_VERIFY_USER = baseUrl + "/users/verifyUser";
export const URL_GET_ALL_USER = baseUrl + "/users/getUser";
export const URL_GET_USERS_BY_PROVIDER_NAME =
  baseUrl + "/users/getUserByProviderName?providerName=param&id=param1";
export const URL_GET_CLAIM_LOCKED_STATUS =
  baseUrl + "/transaction/edcGetClaimLockedStatus?ProviderCode=param&id=param1";
export const URL_PUT_CHANGE_STATUS_LOCKED_CLAIM =
  baseUrl + "/transaction/edcChangeStatusClaimLocked";

//For Finger
export const RegisterFinger = baseUrl + "/users/finger";
export const FindFinger = baseUrl + "/users/getfinger";
export const FIND_UNID = baseUrl + "/users/member";
export const FIND_FINGER_UNID = baseUrl + "/users/finger/unid";
export const Validation = baseUrl + "/users/VerifyFinger";
export const FindByFinger = baseUrl + "/users/Matchmember";
//--//

//For Face Recognition
export const URL_POST_NEW_FACE_ID = baseUrl + "/face/enrollFace";
export const URL_GET_ALL_FACE = baseUrl + "/face/getAllFace";
export const URL_GET_EMPLOYEE_DATA =
  baseUrl + "/face/getEmployee?cardreferenceno=param";

//get Clinic for face recognition
export const URL_GET_ONE_CLINIC =
  baseUrl + "/clinic/getOneClinic?providerCode=param";

export const URL_GET_CAPTCHA = baseUrl + "/captcha";
export const URL_GET_CAPTCHA_V2 = baseUrl + "/captchaV2?deviceId=param";
export const URL_VERIFY_CAPTCHA = baseUrl + "/verifyCaptcha";

//All Payment Transaction
export const URL_PAYMENT_TRANSACTION =
  baseUrl + "/edcDiagnostic/processallpayment";

export const URL_F1_SSO = ssoUrl + "/auth/sso";

export const URL_GET_USERS =
  baseUrl +
  "/admin/users?pageSize=$pageSize&page=$page&searchParams=$searchParams&id=$id";
export const URL_VERIFIED_USER = baseUrl + "/admin/users/$userId/status";
export const URL_ENABLE_2FA = baseUrl + "/admin/users/$userId/2FA";
export const URL_CREATE_SESSION = baseUrl + "/admin/users/$id/session";
export const URL_UPDATE_EMAIL = baseUrl + "/admin/users/$userId/email";
export const URL_UPDATE_FULLNAME = baseUrl + "/admin/users/$userId/fullname";
